(function() {
  'use strict';

  var MIN_SPACING = 5;
  var MIN_SPACING_TEXT_ELEMENTS = 20;

  function initCustomBannerCollision(sectionId) {
    var banner = document.getElementById(sectionId);
    if (!banner) return;

    if (banner.__collisionCleanup) {
      banner.__collisionCleanup();
    }

    var isShopifyEditor = window.Shopify && window.Shopify.designMode;

    if (isShopifyEditor) {
      banner.classList.add('banner-content-ready');
      return;
    }

    if (window.matchMedia('(max-width: 749px)').matches) {
      banner.classList.add('banner-content-ready');
      return;
    }

    var originalPositions = {};
    var positionsSaved = false;
    var resizeTimeout;
    var resizeObserver;
    var initialLayoutDone = false;
    var layoutPassPending = false;

    function getElementKey(el) {
      var blockId = el.getAttribute('data-block-id') || '';
      var classes = Array.from(el.classList)
        .filter(function(c) {
          return c.indexOf('custom-banner__') === 0;
        })
        .join('-');
      return blockId || classes || el.className;
    }

    function getPercentPosition(el, bannerRect) {
      var styleAttr = el.getAttribute('style') || '';
      var leftMatch = styleAttr.match(/left:\s*([^;%]+)/);
      var topMatch = styleAttr.match(/top:\s*([^;%]+)/);

      if (leftMatch && topMatch && leftMatch[1].indexOf('%') !== -1 && topMatch[1].indexOf('%') !== -1) {
        return {
          left: leftMatch[1].trim(),
          top: topMatch[1].trim()
        };
      }

      var computed = window.getComputedStyle(el);
      var leftPx = parseFloat(computed.left);
      var topPx = parseFloat(computed.top);

      if (!isNaN(leftPx) && !isNaN(topPx) && bannerRect.width > 0 && bannerRect.height > 0) {
        return {
          left: (leftPx / bannerRect.width) * 100 + '%',
          top: (topPx / bannerRect.height) * 100 + '%'
        };
      }

      var rect = el.getBoundingClientRect();
      if (bannerRect.width > 0 && bannerRect.height > 0) {
        return {
          left: ((rect.left - bannerRect.left) / bannerRect.width) * 100 + '%',
          top: ((rect.top - bannerRect.top) / bannerRect.height) * 100 + '%'
        };
      }

      return { left: '50%', top: '50%' };
    }

    function clearInlinePositions() {
      banner.querySelectorAll('.custom-banner__heading, .custom-banner__text, .custom-banner__buttons').forEach(function(el) {
        el.style.left = '';
        el.style.top = '';
      });
    }

    function resetPositionCache() {
      originalPositions = {};
      positionsSaved = false;
    }

    function saveOriginalPositions() {
      var bannerRect = banner.getBoundingClientRect();
      if (bannerRect.width === 0 || bannerRect.height === 0) return false;

      banner.querySelectorAll('.custom-banner__heading, .custom-banner__text, .custom-banner__buttons').forEach(function(el) {
        if (!isLayoutVisible(el)) return;

        var id = getElementKey(el);
        var pos = getPercentPosition(el, bannerRect);
        originalPositions[id] = {
          left: pos.left,
          top: pos.top,
          element: el
        };
      });

      positionsSaved = Object.keys(originalPositions).length > 0;
      return positionsSaved;
    }

    function restoreOriginalPositions() {
      Object.keys(originalPositions).forEach(function(id) {
        var original = originalPositions[id];
        var el = original.element;
        if (!el || !document.contains(el)) return;
        if (original.left) el.style.left = original.left;
        if (original.top) el.style.top = original.top;
      });
    }

    function isLayoutVisible(el) {
      var style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden') return false;

      if (el.classList.contains('custom-banner__buttons')) {
        var childButtons = el.querySelectorAll('.custom-banner__button');
        for (var i = 0; i < childButtons.length; i++) {
          var childStyle = window.getComputedStyle(childButtons[i]);
          if (childStyle.display !== 'none' && childStyle.visibility !== 'hidden') {
            return true;
          }
        }
        return false;
      }

      return true;
    }

    function getAxisPercent(el, axis) {
      var inline = parseFloat(el.style[axis]);
      if (!isNaN(inline)) return inline;

      var original = originalPositions[getElementKey(el)];
      if (original && original[axis]) return parseFloat(original[axis]);

      var bannerRect = banner.getBoundingClientRect();
      var size = axis === 'left' ? bannerRect.width : bannerRect.height;
      if (size <= 0) return 0;

      var computedPx = parseFloat(window.getComputedStyle(el)[axis]);
      if (!isNaN(computedPx)) return (computedPx / size) * 100;

      return 0;
    }

    function applyMinSpacing(skipRestore) {
      if (!positionsSaved && !saveOriginalPositions()) return;
      if (!skipRestore) restoreOriginalPositions();

      var bannerRect = banner.getBoundingClientRect();
      var elements = Array.from(
        banner.querySelectorAll('.custom-banner__heading, .custom-banner__text, .custom-banner__buttons')
      ).filter(isLayoutVisible);

      if (elements.length < 2) return;

      elements.sort(function(a, b) {
        var rectA = a.getBoundingClientRect();
        var rectB = b.getBoundingClientRect();
        var topDiff = rectA.top - rectB.top;
        if (Math.abs(topDiff) < 5) return rectA.left - rectB.left;
        return topDiff;
      });

      for (var i = 0; i < elements.length - 1; i++) {
        var currentEl = elements[i];
        var nextEl = elements[i + 1];
        var currentRect = currentEl.getBoundingClientRect();
        var nextRect = nextEl.getBoundingClientRect();

        var isCurrentButton = currentEl.classList.contains('custom-banner__buttons');
        var isNextButton = nextEl.classList.contains('custom-banner__buttons');
        var bothAreButtons = isCurrentButton && isNextButton;
        var isSameVerticalLevel = Math.abs(currentRect.top - nextRect.top) < 5;

        if (bothAreButtons && isSameVerticalLevel) {
          var horizontalGap = nextRect.left - currentRect.right;
          if (horizontalGap < MIN_SPACING && nextRect.left < currentRect.right) {
            var currentLeftPercent = getAxisPercent(currentEl, 'left');
            var newLeftPx =
              (currentLeftPercent / 100) * bannerRect.width + currentRect.width + MIN_SPACING;
            var newLeftPercent = (newLeftPx / bannerRect.width) * 100;
            if (newLeftPercent < 95) nextEl.style.left = newLeftPercent + '%';
          }
          continue;
        }

        var isTextOnlyPair =
          (currentEl.classList.contains('custom-banner__heading') ||
            currentEl.classList.contains('custom-banner__text')) &&
          (nextEl.classList.contains('custom-banner__heading') ||
            nextEl.classList.contains('custom-banner__text'));

        var spacingToUse = isTextOnlyPair ? MIN_SPACING_TEXT_ELEMENTS : MIN_SPACING;
        var verticalGap = nextRect.top - currentRect.bottom;

        if (verticalGap < spacingToUse) {
          var currentTopPercent = getAxisPercent(currentEl, 'top');
          var currentTopPx = (currentTopPercent / 100) * bannerRect.height;
          var newTopPx = currentTopPx + currentRect.height + spacingToUse;
          var newTopPercent = (newTopPx / bannerRect.height) * 100;

          if (newTopPercent < 95) nextEl.style.top = newTopPercent + '%';
        }
      }
    }

    function waitForStableLayout(callback) {
      requestAnimationFrame(function() {
        requestAnimationFrame(callback);
      });
    }

    function finishLayoutPass() {
      layoutPassPending = false;
      banner.classList.add('banner-content-ready');
    }

    function runInitialLayout() {
      if (layoutPassPending || banner.classList.contains('banner-content-ready')) return;
      layoutPassPending = true;

      waitForStableLayout(function() {
        resetPositionCache();
        if (!saveOriginalPositions()) {
          layoutPassPending = false;
          setTimeout(runInitialLayout, 100);
          return;
        }
        applyMinSpacing(false);
        applyMinSpacing(true);
        initialLayoutDone = true;
        finishLayoutPass();
      });
    }

    function runResizeLayout() {
      if (!initialLayoutDone) return;
      layoutPassPending = true;

      clearInlinePositions();
      resetPositionCache();

      waitForStableLayout(function() {
        if (!saveOriginalPositions()) {
          layoutPassPending = false;
          return;
        }
        applyMinSpacing(false);
        applyMinSpacing(true);
        finishLayoutPass();
      });
    }

    function scheduleResizeLayout() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(runResizeLayout, 250);
    }

    function onWindowResize() {
      scheduleResizeLayout();
    }

    function waitForBannerImage() {
      var bannerImage = banner.querySelector('.banner__media img.banner__image');
      if (!bannerImage) return Promise.resolve();

      if (bannerImage.complete && bannerImage.naturalHeight > 0) {
        return Promise.resolve();
      }

      return new Promise(function(resolve) {
        var done = false;
        function finish() {
          if (done) return;
          done = true;
          resolve();
        }
        bannerImage.addEventListener('load', finish, { once: true });
        bannerImage.addEventListener('error', finish, { once: true });
        setTimeout(finish, 800);
      });
    }

    function start() {
      var fontsReady = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();

      Promise.all([fontsReady, waitForBannerImage()])
        .then(function() {
          runInitialLayout();
        })
        .catch(function() {
          runInitialLayout();
        });

      setTimeout(function() {
        if (!banner.classList.contains('banner-content-ready')) runInitialLayout();
      }, 2000);
    }

    window.addEventListener('resize', onWindowResize);

    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(function() {
        if (initialLayoutDone) scheduleResizeLayout();
      });
      resizeObserver.observe(banner);
    }

    banner.__collisionCleanup = function() {
      clearTimeout(resizeTimeout);
      window.removeEventListener('resize', onWindowResize);
      if (resizeObserver) resizeObserver.disconnect();
      delete banner.__collisionCleanup;
    };

    start();
  }

  if (typeof window.initCustomBannerCollision === 'undefined') {
    window.initCustomBannerCollision = initCustomBannerCollision;

    document.addEventListener('shopify:section:load', function(event) {
      var banner = event.target.querySelector('[id^="CustomBanner-"]');
      if (banner && window.initCustomBannerCollision) {
        window.initCustomBannerCollision(banner.id);
      }
    });

    document.addEventListener('shopify:section:unload', function(event) {
      var banner = event.target.querySelector('[id^="CustomBanner-"]');
      if (banner && banner.__collisionCleanup) {
        banner.__collisionCleanup();
      }
    });
  }
})();
